module.exports = __webpack_public_path__ + "static/media/add.d446a81e.svg";